<section class="viewer-header align-items-center">
  <a class="btn d-flex py-3" matRipple [matTooltip]="'Back'" (click)="closeViewer.emit(true)">
    <mat-icon>arrow_back</mat-icon>
  </a>
  <div class="has-border">
    <h1>Back to {{ view == 'meeting' ? 'Meeting' : 'Message' }}</h1>
  </div>

  <div class="histo-logo">
    <img src="./assets/images/logo/histo-app-logo.svg" alt="">
  </div>
</section>

<section class="viewer-wrapper" [class.multi-viewer]="isMultiViewer || showSidebarLeft" [class.anonymous]="anonymous">
  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <div class="row m-0 main-container" [hidden]='dataLoading'>
    <div class="sidebar-left" #sideLeft [ngClass]="{'sidebar-minimized':!showSidebarLeft}"
      *ngIf="activeSlide && activeSlide.annotorious && !activeSlide.annotorious.readOnly && showResults">
      <div class="sidebar-wrapper">
        <div class="results-side-sheet"
          *ngIf="activeSlide && showResults && showSidebarLeft">
          <app-viewer-image-analysis-result #sideSheetResult [scrollToId]="activeSlide.scrollToId"
            [allFeedbacks]="activeSlide.allFeedbacks" (zoomEvent)="zoomToDetection($event)"
            (closeEvent)="showResults = false" [slide]="activeSlide" (showDetection)="showDetectionResults = $event"
            [showDetectionResult]="showDetectionResults" (selectAnnEvent)="selectAnn($event, activeSlide,true)"
            (cellTypesCountingEvent)="showcellTypesCounting = true;showResults = false"></app-viewer-image-analysis-result>
        </div>
      </div>
      <div class="sidebar-action">
        <button (click)="showSidebarLeft = !showSidebarLeft;showSidebarRight = !showSidebarLeft;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9">
            <path id="arrow"
              d="M245.52-631a1.478,1.478,0,0,0-.59.125,1.575,1.575,0,0,0-.5.343l-6.468,6.1a1.3,1.3,0,0,0-.457.993,1.355,1.355,0,0,0,.463,1.014,1.509,1.509,0,0,0,1.074.421,1.563,1.563,0,0,0,1.088-.418l5.392-5.1,5.408,5.1a1.484,1.484,0,0,0,1.055.418,1.547,1.547,0,0,0,1.074-.421,1.394,1.394,0,0,0,.446-1.029,1.336,1.336,0,0,0-.441-1.009l-6.435-6.073a1.794,1.794,0,0,0-.517-.343A1.454,1.454,0,0,0,245.52-631Z"
              transform="translate(-237.5 631)" />
          </svg>
          <span>Image analysis</span>
        </button>
      </div>
    </div>

    <div class="viewer-content"
      [ngClass]="{'toggledSidebar':!showSidebarRight && showSidebarLeft,'full-width':!showSidebarRight && !showSidebarLeft,'other-role':!activeSlide || !activeSlide.annotorious || (activeSlide && activeSlide.annotorious && activeSlide.annotorious.readOnly)}">
      <div class="viewer-container" id="fullscreenContainer">
        <div [id]="'annotation-tooltip'" class="annotation-tooltip hidden"></div>

        <ng-container *ngIf="!isMultiViewer && activeSlide">
          <ng-container *ngIf="!showSidebarLeft" [ngTemplateOutlet]="toolbar"
            [ngTemplateOutletContext]='{slide: activeSlide}'></ng-container>
          <div class="row h-100">
            <div class="slides-0 active-slide col-12">
              <div class="slide-head" *ngIf="showSidebarLeft">
                <span>Slide</span>
                <ng-container [ngTemplateOutlet]="toolbar"
                  [ngTemplateOutletContext]='{slide: activeSlide}'></ng-container>
              </div>
              <ng-container [ngTemplateOutlet]="slideViewer" [ngTemplateOutletContext]='{slide: activeSlide}'>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isMultiViewer">
          <div class="row h-100">
            <div class="slides-{{slides.length}}" *ngFor="let slide of slides; index as i"
              [class.active-slide]="slide.isActive" [ngClass]="showSidebarLeft?'col-12':'col-6'"
              [hidden]="showSidebarLeft && !slide.isActive">
              <div class="slide-head">
                <span>Slide #{{i+1}}</span>
                <ng-container [ngTemplateOutlet]="toolbar" [ngTemplateOutletContext]='{slide: slide}'></ng-container>
              </div>
              <ng-container [ngTemplateOutlet]="slideViewer" [ngTemplateOutletContext]='{slide: slide}'></ng-container>
              <div class="overlay" *ngIf="!slide.isActive" (click)="activateSlide(slide)"></div>
            </div>
          </div>
        </ng-container>

        <ng-template #slideViewer let-slide="slide">
          <div *ngIf="slide.details && !slide.details.tilesFolderName"
            class="h-100 d-flex align-items-center justify-content-center text-bold">
            Slide under processing
          </div>
          <div class="slide-dragon-inner" [hidden]="slide.details && !slide.details.tilesFolderName">
            <div class="slide-dragon-wrapper" [id]="'openseadragon-' + slide.index" #dragonViewer></div>
            <div class="slide-zoom" [hidden]="!slide.isActive">
              <span>{{slide.imageZoom}}</span>%
            </div>
          </div>
        </ng-template>

      </div>
    </div>

    <div class="sidebar-right" [ngClass]="{'sidebar-minimized':!showSidebarRight}">
      <div class="sidebar-toolbar-vertical" [hidden]="showSidebarRight">
        <button (click)="showSidebarRight = !showSidebarRight;showSidebarLeft = false">
          <span>Show side</span>
          <img src="./assets/images/viewer-icons/hide-panel-left.svg" alt="">
        </button>
      </div>
      <div class="sidebar-wrapper">
        <div class="sidebar-toolbar">
          <button (click)="showSidebarRight = !showSidebarRight">
            <span>Hide Sidebar</span>
            <img src="./assets/images/viewer-icons/hide-panel.svg" alt="">
          </button>
        </div>
        <div class="navigator" *ngFor="let slide of slides; index as i" [hidden]="!slide.isActive">
          <div class="zoom-btns">
            <button mat-button [id]="'zoomInButton-' + slide.index" matTooltip="Zoom In">
              <img src="./assets/images/viewer-icons/zoom-in.svg" alt="">
            </button>
            <button mat-button [id]="'zoomOutButton-' + slide.index" matTooltip="Zoom Out">
              <img src="./assets/images/viewer-icons/zoom-out.svg" alt="">
            </button>
            <button mat-button [id]="'homeButton-' + slide.index" matTooltip="Reset Zoom"
              *ngIf="slides.length && slides.length > 1">
              <img src="./assets/images/viewer-icons/zoom-reset.svg" alt="">
            </button>
            <button mat-button [id]="'fullPageButton1-' + slide.index" matTooltip="Full Screen" (click)="fullScreen()">
              <img src="./assets/images/viewer-icons/full-screen.svg" alt="">
            </button>
            <button mat-button [id]="'rotateLeftButton-' + slide.index" matTooltip="Rotate Left">
              <img src="./assets/images/viewer-icons/rotate-left.svg" alt="">
            </button>
            <button mat-button [id]="'rotateRightButton-' + slide.index" matTooltip="Rotate Right">
              <img src="./assets/images/viewer-icons/rotate-right.svg" alt="">
            </button>
          </div>
          <div class="navigator-wrapper">
            <div class="zomm_levels_btns">
              <button mat-button [matTooltip]="item.tooltip" [class.active]="item.value == zoomlevelAll"
                (click)="goToZoomLevel(item.value)" *ngFor="let item of zoomLevelsList">
                {{item.name}}
              </button>
            </div>
            <div>
              <div class="navigator-container" [id]="'navigator-container-' + slide.index"></div>
            </div>

            <div class="opacity-slider">
              <label><img src="./assets/images/viewer-icons/transparency-opacity.svg" alt=""> Remarks Opacity</label>
              <div>
                <mat-slider class="w-100" min="1" max="9" step="1" [(ngModel)]="slide.opacityValue"
                  (ngModelChange)='setFillColor()'></mat-slider>
              </div>
            </div>

            <div class="opacity-slider">
              <label><img src="./assets/images/viewer-icons/transparency-opacity.svg" alt=""> Image Brightness</label>
              <div>
                <mat-slider class="w-100" min="-1" max="400" [(ngModel)]="slide.brightness"
                  (ngModelChange)='setFillBrightness()'></mat-slider>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="opacity-slider rgb-slider">
                  <label>Red: ({{slide.redColor}})</label>
                  <div>
                    <mat-slider class="w-100" min="0" max="255" [(ngModel)]="slide.redColor"
                      (ngModelChange)='setFillBrightness()'></mat-slider>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="opacity-slider rgb-slider">
                  <label>Green: ({{slide.greenColor}})</label>
                  <div>
                    <mat-slider class="w-100" min="0" max="255" [(ngModel)]="slide.greenColor"
                      (ngModelChange)='setFillBrightness()'></mat-slider>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="opacity-slider rgb-slider">
                  <label>Blue: ({{slide.blueColor}})</label>
                  <div>
                    <mat-slider class="w-100" min="0" max="255" [(ngModel)]="slide.blueColor"
                      (ngModelChange)='setFillBrightness()'></mat-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>

          <div class="viewer-tabs">

            <mat-tab-group>
              <mat-tab label="Remarks">
                <div class="tab-container">
                  <div class="tab-title">
                    <h3>Remarks <span
                        *ngIf="activeSlide.allFeedbacks.length">({{activeSlide.allFeedbacks.length}})</span>
                    </h3>
                  </div>
                  <div class="tab-content">
                    <div *ngIf='loading || dataLoading' class="dataLoading">
                      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                    </div>
                    <ng-container *ngIf="!loading && !dataLoading">
                      <div class="data-empty m-0" *ngIf="!activeSlide.details || !activeSlide.allFeedbacks || !activeSlide.allFeedbacks.length">
                        <p>{{ 'general.NoFound' | translate }}</p>
                      </div>
                      <ul class="anno-list" #remarks
                        *ngIf="activeSlide.details && activeSlide.allFeedbacks && activeSlide.allFeedbacks.length">
                        <li [class.active]="activeSlide.selectedAnno == item.id"
                          *ngFor="let item of activeSlide.allFeedbacks; index as i"
                          (click)="selectAnn(item.id, activeSlide)">

                          <div class="d-flex align-items-center justify-content-between">
                            <div>
                              <h2>Remark #{{i+1}}</h2>
                              <div class="user-badge" *ngIf="item.remarksByName">
                                <div class="badge-img">
                                  <div class="badge-img">
                                    <img *ngIf="item.remarksByImage" [src]="item.remarksByImage"
                                      (error)="item.remarksByImage = ''" />
                                    <span *ngIf="!item.remarksByImage"
                                      [innerHTML]="item.remarksByName | shortName"></span>
                                  </div>
                                </div>
                                <div class="badge-text">
                                  <h4>{{item.remarksByName}}</h4>
                                  <h6>{{item.body[0].created | date:'d MMM, y hh:mm a'}}</h6>
                                </div>
                              </div>
                            </div>
                          </div>

                        </li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </mat-tab>

              <mat-tab label="Comments">
                <div class="tab-container" #comments>
                  <app-comments [slideId]='activeSlide.id'></app-comments>
                </div>
              </mat-tab>
              <mat-tab label="Label" *ngIf="activeSlide.details && activeSlide.details.hasLabel">
                <div class="tab-container">
                  <div class="tab-title">
                    <h3>Click on the image to view in full screen</h3>
                  </div>
                  <div class="tab-content">
                    <a class="labels_img_container" [href]="activeSlide.details.labelName" target="_blank">
                      <img [src]="activeSlide.details.labelName" alt="">
                    </a>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>

          </div>

        </div>
      </div>

    </div>


    <div class="cant-open w-100 h-100">
      <div class="w-100 h-100 d-flex align-items-center justify-content-center">
        <h5>To view and use all features, Please use larg screen</h5>
      </div>
    </div>
  </div>
</section>

<ng-template #toolbar let-slide="slide">
  <div class="toolbar">
    <div [hidden]='dataLoading'>
      <button mat-button matTooltip="Rectangle / Q"
        [class.active]="slide.drawTool == 'rect'" (click)="enableDraw('rect', slide)">
        <svg width="20" height="15" viewBox="0 0 20 15">
          <path id="rectangle"
            d="M18.273,4H3.727A2.771,2.771,0,0,0,1,6.813v9.375A2.771,2.771,0,0,0,3.727,19H18.273A2.771,2.771,0,0,0,21,16.188V6.813A2.771,2.771,0,0,0,18.273,4Zm.909,12.188a.924.924,0,0,1-.909.938H3.727a.924.924,0,0,1-.909-.937V6.813a.924.924,0,0,1,.909-.938H18.273a.924.924,0,0,1,.909.938Z"
            transform="translate(-1 -4)" fill="#7d4393" />
        </svg>
      </button>
      <button mat-button matTooltip="Polygon / Y"
        [class.active]="slide.drawTool == 'polygon'" (click)="enableDraw('polygon', slide)">
        <svg width="20" height="18" viewBox="0 0 20 18">
          <path id="polygon"
            d="M21.862,11.7l-4.5-7.976a1,1,0,0,0-.87-.512h-9a1,1,0,0,0-.87.512L2.13,11.7a1.045,1.045,0,0,0,0,1.024l4.5,7.976a1,1,0,0,0,.87.512h9a1,1,0,0,0,.87-.512l4.5-7.976A1.045,1.045,0,0,0,21.862,11.7Zm-6,7.464H8.078L4.149,12.21,8.078,5.258h7.837l3.928,6.952Z"
            transform="translate(-1.996 -3.21)" fill="#7d4393" />
        </svg>
      </button>
      <button mat-button matTooltip="Ellipse / E"
        [class.active]="slide.drawTool == 'ellipse'" (click)="enableDraw('ellipse', slide)">
        <svg id="ellipse" width="24" height="24" viewBox="0 0 24 24">
          <rect id="path" width="24" height="24" fill="none" />
          <path id="ellipse-2" data-name="ellipse"
            d="M12,2C6.477,2,2,5.582,2,10s4.477,8,10,8,10-3.582,10-8S17.523,2,12,2Zm0,14.4c-4.418,0-8-2.865-8-6.4s3.582-6.4,8-6.4,8,2.865,8,6.4S16.418,16.4,12,16.4Z"
            transform="translate(0 2)" fill="#7d4393" />
        </svg>
      </button>
      <button mat-button matTooltip="Circle / C"
        [class.active]="slide.drawTool == 'circle'" (click)="enableDraw('circle', slide)">
        <svg id="circle" width="24" height="24" viewBox="0 0 24 24">
          <rect id="path" width="24" height="24" fill="none" />
          <path id="circle-2" data-name="circle"
            d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" fill="#7d4393" />
        </svg>
      </button>
      <button mat-button matTooltip="Pen / P"
        [class.active]="slide.drawTool == 'freehand'" (click)="enableDraw('freehand', slide)">
        <svg id="free-hand-pen" width="24" height="24" viewBox="0 0 24 24">
          <rect id="path" width="24" height="24" fill="none" />
          <path id="free-hand-pen-2" data-name="free-hand-pen"
            d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29a1.014,1.014,0,0,0-1.42,0L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"
            transform="translate(0 0)" fill="#7d4393" />
        </svg>
      </button>
      <button mat-button matTooltip="Screenshot" (click)="screenshot(slide)">
        <svg id="download-slide-as-image" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <rect id="path" width="24" height="24" fill="none" />
          <path id="Path_20444" data-name="Path 20444"
            d="M21.718,6.038a.952.952,0,0,0-1.352,0L19.138,7.276V1.952a.952.952,0,1,0-1.9,0V7.276L16.006,6.038A.956.956,0,0,0,14.654,7.39l2.856,2.857a.952.952,0,0,0,.314.2.9.9,0,0,0,.724,0,.952.952,0,0,0,.314-.2L21.718,7.39a.953.953,0,0,0,0-1.352Zm-3.532,6.39a.952.952,0,0,0-.952.952v.362l-1.409-1.41a2.656,2.656,0,0,0-3.742,0L11.416,13,9.055,10.638a2.713,2.713,0,0,0-3.742,0L3.9,12.048V6.714a.952.952,0,0,1,.952-.952h7.617a.952.952,0,0,0,0-1.9H4.856A2.857,2.857,0,0,0,2,6.714V18.143A2.857,2.857,0,0,0,4.856,21H16.282a2.857,2.857,0,0,0,2.856-2.857V13.381A.952.952,0,0,0,18.186,12.429ZM4.856,19.1a.952.952,0,0,1-.952-.952v-3.4l2.761-2.762a.752.752,0,0,1,1.038,0L10.721,15h0l4.094,4.1Zm12.378-.952a.848.848,0,0,1-.171.5l-4.294-4.314.666-.667a.733.733,0,0,1,1.047,0l2.752,2.771Z"
            transform="translate(0 1)" fill="#7d4393" />
        </svg>
      </button>

      <!-- <div class="form-group" *ngIf="slides && slides.length && slides.length > 1">
        <mat-form-field>
          <mat-label></mat-label>
          <mat-select disableOptionCentering [(ngModel)]="slide.zoomlevelSelected"
            (selectionChange)='goToZoomLevel($event.value,slide)'>
            <mat-option [value]="item.value" *ngFor="let item of zoomLevelsList">
              <span>{{item.value?item.name:'Default'}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
    </div>
  </div>
</ng-template>

<ng-template #sidesheet let-slide="slide">
  <app-viewer-detection-result class="w-100" #sideSheetResult *ngIf="showDetectionResults"
    (hideDetection)="showDetectionResults = false" [slide]="slide" (zoomEvent)="zoomToDetection($event)"
    [scrollToId]="slide.scrollToId"></app-viewer-detection-result>
</ng-template>
